

















import { Component, Vue, Prop } from 'vue-property-decorator'
import { isChinese } from '@/utils/validate'
@Component({
  name: 'avatar',
  components: {
  },
  filters: {
    nameFilter: (type: any) => {
      if (isChinese(type)) {
        return type.substring(type.length - 2)
      } else {
        return type.substring(0, 2)
      }
    }
  }
})
export default class extends Vue {
  @Prop({default: '' }) public userName!: string
  @Prop({default: '' }) public imgUrl!: string
  @Prop({default: 'iconfont iconshenpi'}) public icon!: string
  @Prop({default: 32 }) public size!: number
}
